import { useState, useEffect, useCallback } from 'react'
import { getNextMessage, resetToMain, getAllMessages } from '@/utils/textCycler'

export function useMessageCycler(intervalMs = 5000) {
  const [message, setMessage] = useState<string>(getAllMessages()[0])
  const [isPaused, setIsPaused] = useState(false)

  const nextMessage = useCallback(() => {
    setMessage(getNextMessage())
  }, [])

  const reset = useCallback(() => {
    resetToMain()
    setMessage(getAllMessages()[0])
  }, [])

  useEffect(() => {
    if (isPaused) return

    const interval = setInterval(() => {
      nextMessage()
    }, intervalMs)

    return () => clearInterval(interval)
  }, [intervalMs, isPaused, nextMessage])

  return {
    message,
    nextMessage,
    reset,
    pause: () => setIsPaused(true),
    resume: () => setIsPaused(false),
    isPaused
  }
}
